/**
 * Utility to send events to Google Analytics 4
 * @param {string} eventName - Name of the event (e.g., 'cta_click')
 * @param {object} params - Additional parameters for the event
 */
export const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, {
      ...params,
      send_to: 'G-LM9F6XT0EX'
    });
  } else {
    console.warn(`GA4: Event "${eventName}" not sent because gtag is not defined.`);
  }
};

/**
 * Common event trackers for the landing page
 */
export const trackCTA = (location, label) => {
  trackEvent('cta_click', {
    cta_location: location,
    cta_label: label
  });
};
